import type { AlgoliaProductHit } from "~/lib/algolia/types"
import { getProductTrackingDataWithCollections } from "~/components/shared/AnalyticsEvents/utils/get-product-tracking-data-with-collections"
import { unlikelyProductToTrackingData } from "~/components/shared/AnalyticsEvents/utils/unlikely-product-to-tracking-data"
import type { TCollectionTree } from "~/managers/CollectionsTreeManager/_data/serializer"

/**
 * The function `serializeListItemTracking` serializes tracking data for a product item with
 * collections and locale information.
 * @param  - 1. `item`: An object of type `AlgoliaProductHit` representing a product hit from Algolia
 * search results.
 * @returns The `serializeListItemTracking` function returns the product tracking data with collections
 * for a given Algolia product hit, based on the provided item, collection tree, and locale.
 */
export function serializeListItemTracking({
  item,
  locale,
}: {
  item: Pick<AlgoliaProductHit, "product">
  collectionTree: TCollectionTree
  locale: string
}) {
  const trackingData = unlikelyProductToTrackingData({ product: item.product, locale })

  return getProductTrackingDataWithCollections(trackingData, item.product, locale)
}
